import { createSlice } from "@reduxjs/toolkit";
import { NotificationType } from "../../components/notifications/notification-component";

interface NotificationConfiguration {
  id: string;
  body?: string;
  notificationType: NotificationType;
}

export interface NotificationState {
  notifications: Array<NotificationConfiguration>;
}

export const initialState: NotificationState = {
  notifications: [],
};

let notificationIdCounter = 1;

const notificationSlice = createSlice({
  name: "notificiationSlice",
  initialState,
  reducers: {
    pushNotification(state, action) {
      const notification = { ...action.payload, id: notificationIdCounter };
      state.notifications?.push(notification);
      notificationIdCounter++;
    },
    removeNotification(state, action) {
      state.notifications = state.notifications!.filter(
        (item) => item.id !== action.payload
      );
    },
    removeAllValidationErrorNotifications(state) {
      state.notifications = state.notifications!.filter(
        (item) =>
          item.notificationType !== NotificationType.importantValidationError
      );
    },
    removeAllNotifications(state) {
      state.notifications = [];
    },
  },
});

export const {
  pushNotification,
  removeNotification,
  removeAllValidationErrorNotifications,
  removeAllNotifications,
} = notificationSlice.actions;

export default notificationSlice.reducer;
